// Module
var code = ` <div id="map"> </div> `;
// Exports
export default code;